import { BookingStatus } from '../constants';

// The operator's own wording lands in bookingStatus ("Pending - Need More Info"), the normalised
// code in bookingStatusCode. Only the code can be compared, and UNKNOWN means the provider may
// have created the booking, so it must never read as confirmed.
const statusByCode = {
  CONFIRMED: BookingStatus.booked,
  PENDING: BookingStatus.pending,
  UNKNOWN: BookingStatus.pending,
  CANCELLED: BookingStatus.cancelled,
  FAILED: BookingStatus.failed,
};

const getTourBookingStatus = (bookingResponse) => {
  if (!bookingResponse) {
    return undefined;
  }

  const code = (bookingResponse.bookingStatusCode || bookingResponse.bookingStatus || '')
    .toString()
    .toUpperCase();
  const status = statusByCode[code] || BookingStatus.pending;
  return status;
};

export default getTourBookingStatus;
